import React from 'react';
import LomavisPostPreview1 from '../../../generic/cards/postPreview/LomavisPostPreview1';
import { useTranslate } from '@tolgee/react';

interface PostData {
  image: string;
  text: string;
  platforms: string[];
  date: string;
}

interface LomavisPostsListPreviewProps {
  posts: PostData[];
}

const LomavisPostsListPreview: React.FC<LomavisPostsListPreviewProps> = ({
  posts
}) => {
  const { t } = useTranslate();
  return (
    <div className="border rounded bg-white p-3">
      <h6 className="fw-bold">{t('lomavisPostsListPreview.posts')}</h6>
      {
        <p className="text-muted small">
          {t('lomavisPostsListPreview.postsHelp')}
        </p>
      }

      <div className="d-flex flex-column gap-2 mt-2">
        {posts.map((post, index) => (
          <LomavisPostPreview1
            key={index}
            image={post.image}
            text={post.text}
            platforms={post.platforms}
            date={post.date}
          />
        ))}
      </div>
    </div>
  );
};

export default LomavisPostsListPreview;
